import { Box, Card, CardContent, CardHeader } from '@freighthub/silhouette-core'
import { ShipmentInterface, UI } from 'features/ShipmentDetails'
import { FC, useState } from 'react'

import { TRANSPORT_MODE_AIR } from '../domain/TransportMode'
import { getContainersPlans } from '../service/TPContainersPlans'
import { TPContainerRow } from './TPContainerRow'
import { TPContainerPdadTable } from './TPContainerTable'
import { TPTableHeader } from './TPPartials'
import { TPTrackBar } from './TPTrack'

interface TransportPlanProps {
  ui: UI
  shipment: ShipmentInterface
}

export const TransportPlan: FC<TransportPlanProps> = ({ shipment, ui }) => {
  const containers = shipment.containers && shipment.containers.length > 0 ? shipment.containers : [null]
  const [currentIndex, setCurrentIndex] = useState(
    containers.length > 0 && shipment.mode !== TRANSPORT_MODE_AIR ? -1 : 0
  )
  // @ts-expect-error TS(2345) FIXME: Argument of type 'ITransportPlan2 | undefined' is ... Remove this comment to see the full error message
  const containersTp = getContainersPlans(shipment.tp, containers)
  const containersWrappers = containers.map((c, i) => ({ c, i }))
  const container = currentIndex === -1 ? null : containers[currentIndex]
  const containerTp = currentIndex === -1 ? null : containersTp[currentIndex]

  const select = (i: number) => {
    setCurrentIndex(currentIndex === i ? -1 : i)
  }

  return (
    <div>
      <Card data-userlane-id="shipment-tp">
        <CardHeader title="Transport Plan" />
        <CardContent>
          <TPTrackBar containersTp={containersTp} />
          {/* air shipments do not have containers */}
          {shipment.mode !== 'air' && <TPTableHeader />}
          {containersWrappers.slice(0, currentIndex !== -1 ? currentIndex : undefined).map((wrapper) => (
            <TPContainerRow
              ui={ui}
              key={wrapper.c._id}
              containerTp={containersTp[wrapper.i]}
              container={wrapper.c}
              onClick={() => select(wrapper.i)}
              i={wrapper.i}
            />
          ))}
          {currentIndex !== -1 && (
            <>
              <Box my={1}>
                <Card>
                  <TPContainerRow
                    ui={ui}
                    // @ts-expect-error TS(2322) FIXME: Type 'Container | null' is not assignable to type ... Remove this comment to see the full error message
                    container={container}
                    containerTp={containersTp[currentIndex]}
                    i={currentIndex}
                    onClick={() => select(currentIndex)}
                    active
                  />
                  {/* @ts-expect-error TS(2322) FIXME: Type 'IContainerTP | null' is not assignable to ty... Remove this comment to see the full error message */}
                  <TPContainerPdadTable containerTp={containerTp} />
                </Card>
              </Box>
              {containersWrappers.slice(currentIndex + 1).map((wrapper) => (
                <TPContainerRow
                  ui={ui}
                  key={wrapper.c._id}
                  container={wrapper.c}
                  containerTp={containersTp[wrapper.i]}
                  onClick={() => select(wrapper.i)}
                  i={wrapper.i}
                />
              ))}
            </>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
